import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["type", "value"]

import { convertYearMonthToInput } from "@/core/helpers/convertDate";
import { computed } from "vue";
import setup from "../setupComposable/setup";
import commonProps from "../props/commonProps";


export default /*#__PURE__*/_defineComponent({
  __name: 'InputCustom',
  props: commonProps,
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;
const { onInput } = setup(emit);

const inputValue = computed(() => {
  if (props.type === "month") {
    return convertYearMonthToInput(props.modelValue);
  }

  return props.modelValue;
});

// Abre o seletor de mês ao clicar em qualquer parte do campo
const abrirSeletor = (event: Event) => {
  if (props.type !== "month") return;

  const input = event.target as HTMLInputElement & { showPicker?: () => void };
  try {
    input.showPicker?.();
  } catch {
    // navegador sem suporte: mantém o comportamento padrão
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.$attrs.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: _normalizeClass({ required: _ctx.$attrs.required })
        }, _toDisplayString(_ctx.$attrs.label), 3))
      : _createCommentVNode("", true),
    _createElementVNode("input", _mergeProps({
      class: "form-control",
      type: _ctx.type,
      value: inputValue.value
    }, _ctx.$attrs, {
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(onInput) && _unref(onInput)(...args))),
      onClick: abrirSeletor
    }), null, 16, _hoisted_1)
  ]))
}
}

})